export enum LOADING_SIZE {
  large = 24,
  medium = 20,
  small = 16,
}
